<template>
    <div>
        <system-preloader v-if="loading"></system-preloader>
        <b-container fluid class="main_layer atmo-page-banner-wrapper">
            <b-form v-on:focusin="alert = false" autocomplete="off" ref="filter" class="w-100">
                <b-container>
                    <b-row>
                        <b-col>
                            <b-row>
                                <b-col>
                                    <h2 class="mb-4">Запросы КП</h2>
                                </b-col>
                            </b-row>
                            <b-row class="filters">
                                <filter-input-text label="Наименование ТРУ" v-model="filter.conditionName" placeholder="Укажите наименование ТРУ" md="6" lg="4" class="mr-0 mb-1" />
                                <filter-input-text label="Заказчик" v-model="filter.customer" placeholder="Укажите наименование/ИНН заказчика" md="6" lg="4" class="mr-0 mb-1" />
                                <filter-input-text label="Рег.номер запроса" v-model="filter.regNumber" placeholder="Укажите рег.номер запроса" md="6" lg="4" class="mr-0 mb-1" />
                                <template v-if="showFilters">
                                    <b-col cols="12" md="6" lg="6" class="mb-3">
                                        <date-time-picker
                                            class="filter_datepicker atmo-form__field mb-0"
                                            id="filter_from_purchase_start"
                                            v-model="filter.orderDateStart"
                                            label="Укажите дату проведения с"
                                            :only-date="true"
                                            formatted="DD.MM.YYYY"
                                            format="YYYY-MM-DD"
                                            buttonNowTranslation="Сегодня"
                                            :no-label="!!filter.orderDateStart"
                                            autoClose />
                                        <span class="fs-10 halfWhite-color">Дата проведения с...</span>
                                    </b-col>
                                    <b-col cols="12" md="6" lg="6" class="mb-3">
                                        <date-time-picker
                                            class="filter_datepicker atmo-form__field mb-0"
                                            id="filter_to_purchase_start"
                                            v-model="filter.orderDateFinish"
                                            label="Укажите дату проведения по"
                                            :only-date="true"
                                            formatted="DD.MM.YYYY"
                                            format="YYYY-MM-DD"
                                            buttonNowTranslation="Сегодня"
                                            :no-label="!!filter.orderDateFinish"
                                            autoClose />
                                        <span class="fs-10 halfWhite-color">Дата проведения по...</span>
                                    </b-col>
                                </template>
                            </b-row>
                            <b-row>
                                <b-col class="atmo-buttons atmo-special atmo-mobile mb-0">
                                    <b-button class="mr-2 text-uppercase atmo-button-inverse" variant="link" v-on:click="getQuotationRequests(false)">Найти </b-button>
                                    <b-button class="mr-2 text-uppercase atmo-button-border-only" variant="link" v-on:click="showOtherFilter">Все фильтры </b-button>
                                    <b-button class="mr-2 text-uppercase atmo-button-border-only" variant="link" v-on:click="clearFilter"> Сбросить </b-button>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                </b-container>
            </b-form>
        </b-container>
        <b-container fluid>
            <b-container>
                <b-row>
                    <b-col>
                        <ul class="category_menu" v-if="!mobileMenu">
                            <li v-for="(category, cIndex) in quotationRequestCategories" :key="'category_' + cIndex">
                                <router-link :to="'/quotation-requests/' + category.path">
                                    {{ category.title }}
                                </router-link>
                            </li>
                        </ul>
                        <div v-if="mobileMenu">
                            <p class="fs-14 fw-600 my-3 green-color d-flex justify-content-between" v-b-toggle="'purchase_category'">
                                {{ activeTab[0].title }}
                                <i class="fa fs-14 fw-600 green-color d-flex align-items-center" :class="{ 'fa-chevron-down': !mobileMenu_show, 'fa-chevron-up': mobileMenu_show }"></i>
                            </p>
                            <b-collapse id="purchase_category" v-model="mobileMenu_show">
                                <ul class="mobile_category_menu">
                                    <li v-for="(category, cIndex) in quotationRequestCategories" :key="'category_' + cIndex" v-on:click="changeCategory(category.path)">
                                        {{ category.title }}
                                    </li>
                                </ul>
                            </b-collapse>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
        </b-container>
        <b-container fluid style="border-top: 2px solid lightgray" id="content-block" class="greyBg">
            <b-container v-if="quotationRequests.length">
                <div style="width: 100%">
                    <b-pagination align="center" v-model="meta.current_page" :total-rows="meta.total" :per-page="meta.per_page" style="padding-bottom: 0" />
                </div>
            </b-container>
            <b-container v-for="quotationRequest in quotationRequests" :key="quotationRequest.id">
                <b-row>
                    <quotation-request-card-open :quotationRequest="quotationRequest" v-if="quotationRequest.status.id === 'started'" @reloadData="getQuotationRequests"> </quotation-request-card-open>
                    <quotation-request-card-closed :quotationRequest="quotationRequest" v-if="quotationRequest.status.id === 'completed'"></quotation-request-card-closed>
                </b-row>
            </b-container>
            <b-container v-if="!loading && !quotationRequests.length">
                <empty-request></empty-request>
            </b-container>
            <b-container v-if="quotationRequests.length">
                <div style="width: 100%">
                    <b-pagination align="center" v-model="meta.current_page" :total-rows="meta.total" @input="getQuotationRequests()" :per-page="meta.per_page" />
                </div>
            </b-container>
        </b-container>
    </div>
</template>

<script>
import QuotationRequestCardOpen from './parts/RequestCardOpen.vue';
import QuotationRequestCardClosed from './parts/RequestCardClosed.vue';

export default {
    name: 'QuotationRequestsList',
    components: {
        QuotationRequestCardOpen,
        QuotationRequestCardClosed
    },
    metaInfo: {
        title: 'Запросы КП'
    },
    data() {
        return {
            mobileMenu_show: false,
            mobileMenu: false,
            filter: {
                conditionName: '',
                customer: '',
                regNumber: '',
                orderDateStart: null,
                orderDateFinish: null,
                priceStartFrom: '',
                priceStartTo: '',
                status: 0
            },
            current_route: null,
            quotationRequestCategories: [
                { title: 'Все', path: 'all', status: '' },
                { title: 'Прием предложений открыт', path: 'new', status: 'started' },
                { title: 'Прием предложений завершен', path: 'end', status: 'completed' }
            ],
            loading: true,
            quotationRequests: [],
            showFilters: false,
            options: {
                format: 'YYYY-MM-DD',
                useCurrent: false
            },
            meta: {
                current_page: 1,
                total: 0,
                per_page: 1
            }
        };
    },
    async mounted() {
        document.documentElement.addEventListener('keydown', this.KeyEnterFilter);
        await this.getQuotationRequests();
    },
    created() {
        window.innerWidth <= 767 ? (this.mobileMenu = true) : (this.mobileMenu = false);
        this.current_route = this.$route.params.path;
        this.filter.status = this.getStatus();
    },
    destroyed() {
        document.documentElement.removeEventListener('keydown', this.KeyEnterFilter);
    },
    computed: {
        activeTab() {
            return this.quotationRequestCategories.filter((category) => {
                return category.path.match(this.current_route);
            });
        }
    },
    methods: {
        changeCategory(id) {
            this.$router.push('/quotation-requests/' + id).catch(() => {});
            this.mobileMenu_show = false;
        },
        showOtherFilter(e) {
            this.showFilters = !this.showFilters;
            this.showFilters ? (e.target.innerText = 'Меньше фильтров') : (e.target.innerText = 'Все фильтры');
        },
        clearFilter() {
            this.$refs.filter.reset();
            this.filter = {
                conditionName: '',
                customer: '',
                regNumber: '',
                orderDateStart: null,
                orderDateFinish: null
            };
            this.getQuotationRequests(false);
        },
        KeyEnterFilter(e) {
            if (e.keyCode === 13) {
                this.getQuotationRequests(false);
            }
        },
        getStatus() {
            return this.quotationRequestCategories.find((x) => x.path === this.current_route).status;
        },
        getFilters(page = true) {
            const filterValues = [];
            for (const [key, value] of Object.entries(this.filter)) {
                if (value) {
                    filterValues[key] = value;
                }
            }
            return {
                ...filterValues,
                page: page ? this.meta.current_page : 1
            };
        },
        async getQuotationRequests(page = true, loading = true) {
            this.loading = loading;
            const response = await this.$api.quotationRequests.getList(this.getFilters(page));
            this.quotationRequests = response.data;
            this.meta = response.meta;
            this.loading = false;
        }
    },
    watch: {
        $route(to) {
            this.current_route = to.params.path;
            this.filter.status = this.getStatus();
            this.getQuotationRequests(false);
        }
    },
    beforeRouteEnter(to, from, next) {
        if (Object.keys(to.query).length > 0) {
            next((vm) => {
                let path = to.params.path;
                let queries = to.query;
                vm.filter = JSON.parse(queries.filter);
                vm.$router.replace('/quotation-requests/' + path).catch(() => {});
            });
        } else {
            next();
        }
    }
};
</script>

<style scoped>
.halfWhite-color {
    color: rgba(255, 255, 255, 0.5);
}

.category_menu {
    padding: 0;
    margin-bottom: -2px;
    margin-top: 14px;
    list-style-type: none;
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: stretch;
    -webkit-align-items: stretch;
    -moz-box-align: stretch;
    -ms-flex-align: stretch;
    align-items: stretch;
}

.category_menu li {
    padding-bottom: 9px;
}

.category_menu li + li {
    margin-left: 99px;
}

.category_menu li a {
    font-size: 14px;
    color: var(--grey-color);
    border-bottom: 2px solid transparent;
    text-decoration: none;
    padding-bottom: 9px;
    white-space: nowrap;
}

.router-link-active {
    color: var(--green-color) !important;
    border-bottom-color: var(--green-color) !important;
    font-weight: 400;
}

.show_bg {
    background-color: #f5f5f7;
}

.purchase_part {
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    border-radius: 4px;
    border: 1px solid #d9d9de;
}

.purchase_part-header {
    -webkit-border-radius: 4px 4px 0 0;
    -moz-border-radius: 4px 4px 0 0;
    border-radius: 4px 4px 0 0;
    background-color: var(--green-color);
    padding: 10px 24px;
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -moz-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}

.purchase_part-body {
    padding: 20px 24px;
}

.purchase_part-header_number {
    font-size: 14px;
    color: #fff;
    margin: 0;
    font-weight: 600;
}

.purchase_part-header_label {
    text-transform: uppercase;
    color: #fff;
    margin: 0;
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    font-size: 12px;
}

.purchase_part-body_col + .purchase_part-body_col > div::before {
    content: '';
    width: 1px;
    height: 100%;
    position: absolute;
    background-color: #d9d9de;
    left: 0px;
}

.mobile_category_menu {
    list-style-type: none;
    padding: 0;
    margin: 0;
    margin-bottom: 10px;
}

.mobile_category_menu li {
    padding: 10px 0;
}

.mobile_category_menu li + li {
    border-top: 1px solid var(--green-color);
}

.show_bg {
    background-color: #f5f5f7;
}
@media screen and (max-width: 1200px) {
    .less_font-size_mobile {
        font-size: 40px !important;
    }
}
@media screen and (max-width: 414px) {
    .flex_col-mobile {
        display: -webkit-box;
        display: -webkit-flex;
        display: -moz-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -webkit-flex-direction: column;
        -moz-box-orient: vertical;
        -moz-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
        -webkit-box-align: center;
        -webkit-align-items: center;
        -moz-box-align: center;
        -ms-flex-align: center;
        align-items: center;
    }
}

@media screen and (max-width: 320px) {
    .less_font-size_mobile {
        font-size: 38px !important;
    }
}
</style>

<style lang="less">
@subtext-color: #777;
@preloader-bg-color: rgba(255, 255, 255, 0.75);
@suggestions-bg-color: #fff;
@subtext-label-color: #f5f5f5;

.box-sizing(@sizing: border-box) {
    -ms-box-sizing: @sizing;
    -moz-box-sizing: @sizing;
    -webkit-box-sizing: @sizing;
    box-sizing: @sizing;
}

.rounded(@radius) {
    -webkit-border-radius: @radius;
    -moz-border-radius: @radius;
    border-radius: @radius;
}

.cross-button-mixin() {
    @cross-padding: 20;
    @cross-ray-width: 10;
    @cross-ray-length: 50 - @cross-padding - @cross-ray-width;
    @svg: "<svg width='100' height='100' xmlns='http://www.w3.org/2000/svg'><g><path d='m@{cross-padding},@{cross-padding}m@{cross-ray-width},0l@{cross-ray-length},@{cross-ray-length}l@{cross-ray-length},-@{cross-ray-length}l@{cross-ray-width},@{cross-ray-width}l-@{cross-ray-length},@{cross-ray-length}l@{cross-ray-length},@{cross-ray-length}l-@{cross-ray-width},@{cross-ray-width}l-@{cross-ray-length},-@{cross-ray-length}l-@{cross-ray-length},@{cross-ray-length}l-@{cross-ray-width},-@{cross-ray-width}l@{cross-ray-length},-@{cross-ray-length}l-@{cross-ray-length},-@{cross-ray-length}l@{cross-ray-width},-@{cross-ray-width}' fill='#999'/></g></svg>";
    @svg64: `new Buffer(@{svg}) .toString('base64') `;
    background: transparent url('data:image/svg+xml;base64,@{svg64}') 50% 50% no-repeat;
    background-size: contain;

    cursor: pointer;
    opacity: 0.8;

    &:hover {
        opacity: 1;
    }
}

.suggestions-nowrap {
    white-space: nowrap;
}

/**
     * Основной INPUT
     */
.suggestions-input {
    // IE9 can't determine border-style until it is specified in stylesheets
    //  border: 1px solid grey;
    .box-sizing();
    width: 100%;

    &::-ms-clear {
        display: none;
    }
}

.suggestions-wrapper {
    position: relative;
    margin: 0;
    padding: 0;
    vertical-align: top;

    //Prevent font scaling in landscape while allowing user zoom
    -webkit-text-size-adjust: 100%;
}

/**
     * Блок в правой части основного INPUT'а
     * В нем показывается иконка ЗАГРУЗКА
     */
.suggestions-addon {
    display: none;
    opacity: 0;
    position: absolute;

    &[data-addon-type='spinner'] {
        background: @preloader-bg-color
            url('data:image/gif;base64,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')
            50% 50% no-repeat;
        .rounded(50%);
    }

    &[data-addon-type='clear'] {
        .cross-button-mixin();
    }
}

/**
     * Выпадающий блок с найденными подсказками
     */
.suggestions-suggestions {
    background: @suggestions-bg-color;
    border: 1px solid #999;
    .box-sizing;
    cursor: default;
    z-index: 990;

    //Prevent font scaling in landscape while allowing user zoom
    -webkit-text-size-adjust: 100%;

    strong {
        font-weight: normal;
        color: #3399ff;
    }

    &.suggestions-mobile {
        border-style: none;

        .suggestions-suggestion {
            border-bottom: 1px solid #ddd;
        }
    }
}

/**
     * Контейнер для одной подсказки
     */
.suggestions-suggestion {
    padding: 4px 4px;
    overflow: hidden;

    &:hover {
        background: darken(@suggestions-bg-color, 3%);
    }
}

/**
     * Выбранная (активная) подсказка
     */
.suggestions-selected {
    background: darken(@suggestions-bg-color, 6%);

    &:hover {
        background: darken(@suggestions-bg-color, 6%);
    }
}

/**
     * Информационный блок в верхней части выпадашки с подсказками
     */
.suggestions-hint {
    padding: 4px 4px;
    white-space: nowrap;
    overflow: hidden;
    color: @subtext-color;
    font-size: 85%;
    line-height: 20px;
}

/**
     * Ограничения поиска, показываются в левой части основного INPUT'а
     */
.suggestions-constraints {
    list-style: none !important;
    margin: 0 !important;
    padding: 0 !important;
    position: absolute !important;
    white-space: nowrap !important;

    &:empty {
        display: none !important;
    }

    li {
        background: #f8f8f8;
        border: 1px solid #ccc;
        .rounded(3px);
        cursor: default;
        display: inline-block;
        margin: 0 4px 0 0;
        padding: 0 0.5em;

        .suggestions-remove {
            @icon-size: 1em;
            height: @icon-size;
            width: @icon-size;
            display: inline-block;

            margin: 0 0 0 0.25em;
            .cross-button-mixin();
        }

        span {
            vertical-align: middle;
        }
    }
}

/**
     * Дополнительный текст в подсказке, который идет второй строкой
     */
.suggestions-subtext {
    color: @subtext-color;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/**
     * Размещает дополнительный текст в одну строку с основным текстом подсказки
     */
.suggestions-subtext_inline {
    display: inline-block;
    min-width: 6em;
    vertical-align: bottom;
    margin: 0 0.5em 0 0;
}

/**
     * Разделитель нескольких дополнительных текстов
     */
.suggestions-subtext-delimiter {
    display: inline-block;
    width: 2px;
}

/**
     * Выделяет подсказку
     */
.suggestions-subtext_label {
    margin: 0 0 0 0.25em;
    .rounded(3px);
    padding: 0 3px;

    background: @subtext-label-color;
    font-size: 85%;
}

.suggestions-value {
    &[data-suggestion-status='LIQUIDATED'] {
        position: relative;

        &:after {
            position: absolute;
            left: 0;
            right: 0;
            top: 50%;

            border-top: 1px solid rgba(0, 0, 0, 0.4);

            content: '';
        }
    }
}

/**
     * Промо-блок
     */
.suggestions-promo {
    font-size: 85%;
    display: none;
    color: @subtext-color;
    padding: 4px;
    text-align: center;

    a {
        color: @subtext-color;
        display: block;
        filter: grayscale(100%);
        line-height: 20px;
        text-decoration: none;
    }

    a:hover {
        filter: grayscale(0);
    }

    svg {
        height: 20px;
        vertical-align: bottom;
    }
}

.suggestions-promo-desktop {
    position: absolute;
    top: 0;
    right: 0;
    text-align: left;
}
</style>
